import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';
import { MarketplaceResponse } from '~client/model/admin/marketplace-response';

/**
 * Creates a marketplace for a particular event
 * @param request
 */
export const performCreateMarketplace = (
  request: MarketplaceRequest,
): Observable<MarketplaceResponse> =>
  apiClient.marketplaceAdminController.createMarketplace$(request);



// WEBPACK FOOTER //
// ./interactor/marketplace/perform-create-marketplace.ts